import { isInViewport } from './isInViewport'

type CssSelector = string

export const scrollToElementIfNotVisible = (elementOrSelector?: HTMLElement | CssSelector | null): void => {
  if (typeof elementOrSelector === 'string') {
    const element = document.querySelector(elementOrSelector) as HTMLElement

    scrollToElementIfNotVisible(element)

    return
  }

  if (elementOrSelector && !isInViewport(elementOrSelector as HTMLElement)) {
    elementOrSelector.scrollIntoView({ behavior: 'smooth' })
  }
}
